module.exports = __webpack_public_path__ + "static/img/head.6be39e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head.jpg
// module id = lBov
// module chunks = 1